export default {"src":"/_next/static/image/public/images/something_went_wrong.04cc4f17fefc0bddbd4f4d1f9cc8442b.svg","height":248,"width":499};